import Controller from "./route.controller";
import template from "./route.html";

const route = {
  template,
  controller: Controller,
};

export default route;



// WEBPACK FOOTER //
// ./src/pages/route/route.component.js